import { render, staticRenderFns } from "./notification-popup.vue?vue&type=template&id=fc8bc1f0&scoped=true"
import script from "./notification-popup.vue?vue&type=script&lang=js"
export * from "./notification-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc8bc1f0",
  null
  
)

export default component.exports